import { useForm, UseFormReturnType } from '@mantine/form';
import { athleteStatusOptions } from 'components/form-fields/select-fields/AthleteStatusSelect';
import { AthletePackage } from 'types';

import { ReservationChoice } from '../cancelModalSteps';

export interface CancelFormValues {
  cancelNow: boolean;
  cancellationDate: Date | null;
  athleteStatusOnCancel: Exclude<AthletePackage['athleteStatusOnCancel'], null> | 'No status change';
  cancellationReason: string | null;
  reservationChoice: ReservationChoice | null;
}

export type CancelForm = UseFormReturnType<CancelFormValues>;

const initialValues: CancelFormValues = {
  cancelNow: false,
  cancellationDate: null,
  athleteStatusOnCancel: 'No status change',
  cancellationReason: null,
  reservationChoice: null,
};

export default function useCancelForm(): CancelForm {
  return useForm<CancelFormValues>({
    initialValues,
    validate: {
      cancelNow: (value, values) =>
        !value && values.cancellationDate === null ? 'A cancellation date is required' : null,
      cancellationDate: (value, values) =>
        !values.cancelNow && value === null ? 'A cancellation date is required' : null,
      athleteStatusOnCancel: value =>
        athleteStatusOptions.onEnd.includes(value) ? null : 'Please select a valid status',
      cancellationReason: value => (value ? null : 'A cancellation reason is required'),
    },
  });
}
